angular.module('registration')

.controller('PreRegistrationController', ['$scope', '$q', '$timeout', '$state', 'Notification', 'Registration', 'InvitationEmailHelper', 'BadEmailNotice',
    function ($scope, $q, $timeout, $state, Notification, Registration, InvitationEmailHelper, BadEmailNotice) {

        /**
         * Validate email address - reject if User account or invitation with this email address already exists.
         * 
         * @param {String} email email address to validate
         */
        // Debounced async validation with immediate start when idle
        var emailValidation = {
            inFlight: false,
            latestValue: undefined,
            nextDeferred: undefined,
            timer: undefined,
            debounceMs: 500
        };

        function runEmailValidation(value, targetDeferred) {
            emailValidation.inFlight = true;
            
            InvitationEmailHelper.validate(value, { scope: $scope })
                .then(function () {
                    if (targetDeferred) {
                        targetDeferred.resolve();
                    }
                }, function () {
                    if (targetDeferred) {
                        targetDeferred.reject();
                    }
                })
                .finally(function () {
                    emailValidation.inFlight = false;

                    // If debounce timer already fired and a next promise exists, run it immediately
                    if (!emailValidation.timer && emailValidation.nextDeferred) {
                        var next = emailValidation.nextDeferred;
                        var val = emailValidation.latestValue;
                        emailValidation.nextDeferred = undefined;
                        runEmailValidation(val, next);
                    }
                });
        }

        $scope.checkEmail = function (email) {
            if (!email) {
                if (emailValidation.timer) {
                    $timeout.cancel(emailValidation.timer);
                    emailValidation.timer = undefined;
                }
                emailValidation.latestValue = undefined;
                // Reject to keep field invalid until non-empty
                return $q.reject();
            }

            emailValidation.latestValue = email;

            // If nothing is currently validating, start immediately
            if (!emailValidation.inFlight) {
                // Cancel any pending debounce timer
                if (emailValidation.timer) {
                    $timeout.cancel(emailValidation.timer);
                    emailValidation.timer = undefined;
                }

                var immediateDeferred = $q.defer();
                runEmailValidation(email, immediateDeferred);
                return immediateDeferred.promise;
            }

            // We're busy: debounce and coalesce to the latest request
            if (!emailValidation.nextDeferred) {
                emailValidation.nextDeferred = $q.defer();
            }

            // Reset debounce timer to only run after user stops typing
            if (emailValidation.timer) {
                $timeout.cancel(emailValidation.timer);
            }
            emailValidation.timer = $timeout(function () {
                // Timer fired; if not busy, run now, else wait for current to finish (handled in finally)
                emailValidation.timer = undefined;
                if (!emailValidation.inFlight && emailValidation.nextDeferred) {
                    var next = emailValidation.nextDeferred;
                    var val = emailValidation.latestValue;
                    emailValidation.nextDeferred = undefined;
                    runEmailValidation(val, next);
                }
            }, emailValidation.debounceMs);

            return emailValidation.nextDeferred.promise;
        };

        /**
         * Send pre-registration request to the server and redirect if successful.
         * @param {Object} self_invitation 
         */
        $scope.submitting = false;

        $scope.createSelfInvitation = function(self_invitation) {
            $scope.submitted = true;
            if ($scope.form && $scope.form.$invalid) {
                return;
            }
            // Prevent double submission
            if ($scope.submitting) {
                return;
            }
            $scope.submitting = true;

            Registration.preRegister(self_invitation,
                function success(response) {
                    $state.go('pre_registration_confirmation');
                }, function failure(response) {
                    $scope.submitting = false;

                    var data = response && response.data;
                    var errors = data && data.errors;

                    if (BadEmailNotice.isRejection(data)) {
                        BadEmailNotice.notify(data);
                        return;
                    }

                    // DCL-431: duplicates have always been rejected server-side by
                    // ProviderInvitation#email_exists, but every such 422 used to
                    // surface as a generic error. Reporting the actual reason makes
                    // the submit path as clear as the live check, so a failed or
                    // throttled live check never leaves the user guessing.
                    var messages = (errors && errors.message) || [];

                    if (messages.indexOf('user.exists') !== -1) {
                        Notification.error('user.exists');
                    } else if (messages.indexOf('invitation.exists') !== -1) {
                        Notification.error('invitation.exists');
                    } else {
                        Notification.error('default.error');
                    }
                });
        };
    }])

.controller('PreRegistrationConfirmationController', [
    function () {
    }]);
